import { createContext, Dispatch } from "react";
import {
  IdentityApplicationViewAction,
  IdentityApplicationViewState,
} from "libs/resources/identity/applications/application-views/IdentityApplicationInfo";

export type DeploymentPageAlertType = "added" | "updated" | null;

export interface IApplicationSummaryPageContext {
  state: IdentityApplicationViewState | null;
  dispatch: Dispatch<IdentityApplicationViewAction>;
  apiConfigTabValue?: number;
  setApiConfigTabValue?: (value: number) => void;
  deploymentPageAlert: DeploymentPageAlertType;
  notifyDeploymentAddedOnPage: () => void;
  notifyDeploymentUpdatedOnPage: () => void;
  dismissDeploymentPageAlert: () => void;
}

export const ApplicationSummaryPageContext =
  createContext<IApplicationSummaryPageContext>({
    state: null,
    dispatch: () => {},
    deploymentPageAlert: null,
    notifyDeploymentAddedOnPage: () => {},
    notifyDeploymentUpdatedOnPage: () => {},
    dismissDeploymentPageAlert: () => {},
  });
